import { repoName, redirects, preferredHost } from '../config'
const anime = require('animejs/lib/anime.js')

export function animateLoaderIn() {
  anime.set('#loading', { translateX: '-100%' })
  anime({
    targets: '#loading',
    translateX: '0%',
    duration: 400,
    easing: 'easeOutExpo'
  })
}

export async function animateLoaderOut() {
  if (anime.running.length > 0) {
    await Promise.all(anime.running.map(r => r.finished))
  }
  anime({
    targets: '#loading',
    duration: 400,
    translateX: '100%',
    easing: 'easeOutExpo'
  })
}

export function trackGTM(url) {
  if (process.env.NODE_ENV === 'development') return false
  return window.dataLayer.push({
    event: 'Pageview',
    url: window.location.href
  })
}

export function returnPrismicScript() {
  return { __html: `window.prismic = { endpoint: 'https://${repoName}.cdn.prismic.io/api/v2' }` }
}

export function persistContext(global) {
  // only on the client
  if (typeof window !== 'undefined') {
    // if we have a global but no persisted one
    if (global && !window.nextPrismicGlobal) {
      window.nextPrismicGlobal = global
      return Object.assign({}, global, {
        mobile: window.innerWidth < 800
      })
    }
    if (window.nextPrismicGlobal) {
      return Object.assign({}, window.nextPrismicGlobal, {
        mobile: window.innerWidth < 800
      })
    }
  } else {
    // on server just pass through
    return global
  }
  return false
}

export function gtmHead(GTM) {
  if (process.env.NODE_ENV === 'development') return { __html: `` }
  return {
    __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${GTM}');`
  }
}

export function checkForRedirects(ctx) {
  if (ctx.req && redirects.length > 0) {
    redirects.forEach(redirect => {
      if (redirect.host === ctx.req.headers.host) {
        ctx.res.writeHead(302, { Location: `https://${preferredHost}${redirect.dest}` })
        return ctx.res.end()
      }
    })
  }
}

export function returnCookieScript() {
  return {
    __html: `var cookieConfig = {
        apiKey: 'f0730a01670a0cf09920d5df663b31caaacbd295',
        product: 'PRO_MULTISITE',
        optionalCookies: [
            {
                    name: 'analytics',
                    label: 'Analytics',
                    description: '',
                    cookies: [],
                    onAccept : function(){},
                    onRevoke: function(){}
                },{
                    name: 'marketing',
                    label: 'Marketing',
                    description: '',
                    cookies: [],
                    onAccept : function(){},
                    onRevoke: function(){}
                },{
                    name: 'preferences',
                    label: 'Preferences',
                    description: '',
                    cookies: [],
                    onAccept : function(){},
                    onRevoke: function(){}
                }
        ],

        position: 'RIGHT',
        theme: 'DARK',
        branding: {
            fontColor: "#FFF",
            fontSizeTitle: "1.2em",
            fontSizeIntro: "1em",
            fontSizeHeaders: "1em",
            fontSize: "0.8em",
            backgroundColor: "#E2263C",
            toggleText: "#000",
            toggleColor: "#E2263C",
            toggleBackground: "#fff",
            buttonIcon: null,
            buttonIconWidth: "64px",
            buttonIconHeight: "64px",
            removeIcon: false,
            removeAbout: false
        }
    };
    CookieControl.load( cookieConfig );`
  }
}
